import '.ah{position:relative;}.ssr-plugin'
import '.j8{width:64px;}.ssr-plugin'
import '.j9{height:64px;}.ssr-plugin'
import '.aj{flex-shrink:0;}.ssr-plugin'
import '.b6{position:absolute;}.ssr-plugin'
import '.ja{bottom:-4px;}.ssr-plugin'
import '.i7{right:-4px;}.ssr-plugin'
import '.fr{border-radius:50%;}.ssr-plugin'
import '.d4{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bq{overflow:hidden;}.ssr-plugin'
import '.jb{width:32px;}.ssr-plugin'
import '.jc{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ah j8 j9 aj"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b6 ja i7 fr d4 bq jb jc"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
